import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Camera, ArrowRight } from "@phosphor-icons/react";

export default function HeroSection() {
  return (
    <section
      className="relative overflow-hidden min-h-[92vh] md:h-[85vh] md:min-h-[600px] md:max-h-[800px]"
      data-testid="hero-section"
    >
      {/* Background Image — cover on mobile, height-fitted on desktop */}
      <div
        style={{ backgroundImage: "url('/hero-background.jpg')" }}
        className="absolute inset-0 bg-no-repeat bg-cover bg-[position:70%_center] md:bg-[length:auto_110%] md:bg-[position:85%_30%]"
      />

      {/* Overlay — softer on mobile so the photobooth is still visible */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/85 via-black/45 to-black/85 md:bg-gradient-to-r md:from-black/95 md:via-black/80 md:to-black/20" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/30" />

      {/* Gold accent lines */}
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-[#C9A962] via-[#D4AF37] to-transparent" />
      <div className="absolute top-0 left-0 w-1 h-32 bg-gradient-to-b from-[#C9A962] to-transparent mt-20 ml-8 hidden lg:block" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 h-full flex flex-col justify-start md:justify-center pt-24 md:pt-0 pb-16 md:pb-0">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="max-w-xl lg:max-w-2xl mx-auto md:mx-0 text-center md:text-left"
        >
          {/* Badge */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
            className="inline-flex items-center gap-2 px-4 py-2 md:px-5 md:py-2.5 rounded-full border border-[#C9A962]/50 bg-black/40 backdrop-blur-md mb-6 md:mb-8"
          >
            <span className="w-2 h-2 md:w-2.5 md:h-2.5 rounded-full bg-[#C9A962] animate-pulse" />
            <span className="text-[#C9A962] text-xs md:text-sm font-semibold tracking-wider uppercase">Expérience Premium</span>
          </motion.div>

          <h1 className="text-[2.5rem] leading-[1.1] sm:text-5xl md:text-6xl lg:text-7xl font-black tracking-tight mb-5 md:mb-6 text-white">
            Location de{" "}
            <span className="gradient-text block sm:inline">Photobooth</span>
            <span className="block text-[1.75rem] sm:text-3xl md:text-4xl lg:text-5xl font-extrabold mt-1 md:mt-2 text-white/95">
              à Bourgoin-Jallieu
            </span>
          </h1>

          <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-gray-100 mb-8 md:mb-10 leading-relaxed font-light">
            <span className="block">Location de borne photo premium</span>
            <span className="block">en Nord-Isère et Est Lyonnais.</span>
            <span className="block text-[#C9A962] font-semibold mt-2 md:mt-3">
              Mariages, anniversaires, événements pros.
            </span>
          </p>

          <div className="flex flex-col sm:flex-row gap-3 md:gap-5 items-center md:items-start justify-center md:justify-start">
            <Link to="/reservation" data-testid="hero-reserve-btn" className="w-full sm:w-auto">
              <button className="btn-primary flex items-center justify-center gap-3 w-full sm:w-auto text-base md:text-lg px-6 md:px-10 py-4 md:py-5 font-semibold shadow-lg shadow-[#C9A962]/20 hover:shadow-[#C9A962]/40 transition-shadow">
                <Camera size={22} weight="bold" />
                Réserver maintenant
              </button>
            </Link>
            <Link to="/tarifs-particuliers" data-testid="hero-pricing-btn" className="w-full sm:w-auto">
              <button className="flex items-center justify-center gap-3 w-full sm:w-auto text-base md:text-lg px-6 md:px-10 py-4 md:py-5 font-semibold rounded-full bg-white/10 backdrop-blur-md border border-white/30 text-white hover:bg-white/20 hover:border-white/50 transition-all">
                Voir les tarifs
                <ArrowRight size={20} weight="bold" />
              </button>
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
